import { Button } from "@/atoms-react/button/Button.react.tsx";
import { Modal, ModalContent } from "@/atoms-react/modal/index.react";
import { Themes } from "@/types/theme.ts";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { MouseEvent, MouseEventHandler, ReactNode, useState } from "react";

export const ButtonConfirm = ({
  loading,
  confirmTitle = "Confirm action",
  confirmMessage = "Click on confirm to continue.",
  confirmIcon = <ExclamationCircleIcon />,
  confirmButtonTheme = Themes.primary,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  onClick,
  children,
  ...attrs
}: {
  loading?: boolean;
  confirmTitle?: string | undefined;
  confirmMessage?: string | undefined;
  confirmIcon?: ReactNode | ReactNode[] | undefined;
  confirmButtonTheme?: Themes | undefined;
  confirmButtonText?: string | undefined;
  cancelButtonText?: string | undefined;
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode | ReactNode[];
  // [x: string]: any;
}) => {
  const [inConfirm, setInConfirm] = useState(false);

  const showModal = () => setInConfirm(true);
  const closeModal = () => setInConfirm(false);

  const confirmClick = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    closeModal();
    setTimeout(() => {
      return onClick(e);
    }, 500);
  };

  return (
    <div>
      <Button {...attrs} loading={loading} onClick={showModal}>
        {children}
      </Button>

      <Modal
        className="w-full min-w-xl max-w-xl items-center justify-center sm:w-full"
        open={inConfirm}
        onClose={closeModal}
      >
        <ModalContent title={confirmTitle} text={confirmMessage} icon={confirmIcon}>
          <div className="mt-2 flex justify-end">
            <Button
              theme={Themes.white}
              size="lg"
              className="my-2 mr-4 shadow-none"
              onClick={closeModal}
            >
              {cancelButtonText}
            </Button>
            <Button
              theme={confirmButtonTheme}
              className="my-2 mr-4"
              size="lg"
              onClick={confirmClick}
            >
              {confirmButtonText}
            </Button>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};
